module.exports = __webpack_public_path__ + "img/it-starts-with-georgia-lockup.2cd04a30.png";